import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, UsersIcon, BarChart3Icon, TargetIcon } from 'lucide-react';
export function Slide7FirstPilot() {
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-10 md:px-20 md:py-12 relative overflow-hidden" data-id="element-234">
      <header className="mb-10 max-w-4xl" data-id="element-235">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-236">
          Recommended first pilot:{' '}
          <span className="text-[#E60012]" data-id="element-237">Pre-Congress Insight Snak</span>
        </motion.h2>
        <motion.p className="text-xl text-[#4A5568] font-light" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-238">
          A low-risk way to test HCP interest and gather insights to focus the
          2027 congress strategy.
        </motion.p>
      </header>

      <main className="flex-1 flex items-center justify-between gap-12 h-full" data-id="element-239">
        <div className="flex-1 flex flex-col justify-center space-y-6 h-full" data-id="element-240">
          <motion.div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-241">
            <div className="flex items-center gap-3 mb-3" data-id="element-242">
              <FileTextIcon className="w-6 h-6 text-[#E60012]" data-id="element-243" />
              <h3 className="text-xl font-bold text-[#1A202C]" data-id="element-244">Example Quiz</h3>
            </div>
            <p className="text-[#4A5568] font-medium mb-4 text-lg" data-id="element-245">
              "Before the 2027 congress, what do you see as the biggest
              challenge in IBD patient management today?"
            </p>
            <div className="space-y-2" data-id="element-246">
              {['A. Identifying the right treatment earlier', 'B. Achieving long-term disease control', 'C. Supporting adherence and follow-up'].map((opt, i) => <div key={i} className="p-3 bg-gray-50 rounded-lg border border-gray-200 text-sm font-medium text-[#2D3748]" data-id="element-247">
                  {opt}
                </div>)}
            </div>
          </motion.div>

          <motion.div className="grid grid-cols-2 gap-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} data-id="element-248">
            <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex flex-col gap-3" data-id="element-249">
              <div className="p-2.5 bg-[#6B46C1]/10 rounded-lg w-fit" data-id="element-250">
                <UsersIcon className="w-5 h-5 text-[#6B46C1]" data-id="element-251" />
              </div>
              <div data-id="element-252">
                <h4 className="font-bold text-[#1A202C] text-sm mb-1" data-id="element-253">
                  Peer Result Moment
                </h4>
                <p className="text-xs text-[#4A5568]" data-id="element-254">
                  HCPs see how their peers answered, driving engagement.
                </p>
              </div>
            </div>
            <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex flex-col gap-3" data-id="element-255">
              <div className="p-2.5 bg-[#E60012]/10 rounded-lg w-fit" data-id="element-256">
                <BarChart3Icon className="w-5 h-5 text-[#E60012]" data-id="element-257" />
              </div>
              <div data-id="element-258">
                <h4 className="font-bold text-[#1A202C] text-sm mb-1" data-id="element-259">
                  Strategic Outputs
                </h4>
                <p className="text-xs text-[#4A5568]" data-id="element-260">
                  Identify knowledge gaps and topic interest early.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div className="bg-[#1A202C] text-white p-6 rounded-xl shadow-md flex gap-4 items-start" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.7
        }} data-id="element-261">
            <TargetIcon className="w-8 h-8 text-[#E60012] shrink-0" data-id="element-262" />
            <div data-id="element-263">
              <h4 className="font-bold text-lg mb-1" data-id="element-264">
                Makes all other activities better
              </h4>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-265">
                This pilot gives Takeda and its agencies early data that
                sharpens the main 2027 congress strategy. It does not require a
                full congress transformation to start.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Mobile Mockup */}
        <motion.div className="w-[300px] h-[600px] bg-white rounded-[36px] shadow-2xl border-[8px] border-gray-900 relative overflow-hidden shrink-0" initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-266">
          {/* Notch */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-6 bg-gray-900 rounded-b-xl z-20" data-id="element-267" />

          {/* Screen Content */}
          <div className="w-full h-full bg-[#F8F9FA] flex flex-col" data-id="element-268">
            <div className="bg-[#E60012] text-white p-6 pt-12 pb-8 rounded-b-3xl shadow-md relative z-10" data-id="element-269">
              <div className="text-[10px] font-bold uppercase tracking-wider mb-2 opacity-80" data-id="element-270">
                Congress 2027 Prep
              </div>
              <h3 className="text-lg font-bold leading-tight" data-id="element-271">
                What is your biggest challenge in IBD management?
              </h3>
            </div>

            <div className="p-5 flex-1 flex flex-col gap-3 mt-2" data-id="element-272">
              {['Identifying the right treatment earlier', 'Achieving long-term disease control', 'Supporting adherence and follow-up'].map((opt, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center justify-between group hover:border-[#E60012] transition-colors cursor-pointer" data-id="element-273">
                  <span className="text-sm font-medium text-[#2D3748] pr-2" data-id="element-274">
                    {opt}
                  </span>
                  <div className="w-4 h-4 rounded-full border-2 border-gray-300 group-hover:border-[#E60012] shrink-0" data-id="element-275" />
                </div>)}
            </div>

            <div className="p-5 bg-white border-t border-gray-100" data-id="element-276">
              <button className="w-full py-3 bg-[#E60012] text-white rounded-xl font-bold text-sm shadow-md hover:bg-red-700 transition-colors" data-id="element-277">
                Submit & See Results
              </button>
            </div>
          </div>
        </motion.div>
      </main>
    </div>;
}